import LnIcon from '../LnIcon';
import classes from './DragHandle.module.scss';
export function DragHandle( props:{className?:string} ) {

    return (
      <button type="button" className= {`${classes.handle} ${props.className} `} >
        <LnIcon name="draghandle" className='icon-small' />
      </button>
    )
}